import React from "react";

export const Ornament = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-4 text-[#9A8640] ${className}`} aria-hidden="true">
    <span className="h-px w-14 bg-[#9A8640]/60" />
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z" fill="currentColor" opacity="0.85"/>
    </svg>
    <span className="h-px w-14 bg-[#9A8640]/60" />
  </div>
);

export const SectionOverline = ({ children, className = "" }) => (
  <p className={`text-xs sm:text-sm uppercase tracking-[0.28em] text-[#9A8640] ${className}`}>
    {children}
  </p>
);

export default Ornament;
